import React, {useEffect, useRef} from 'react';
import {assert, generateHeapObjID, getClassInstanceMetadata, isPrimitiveType} from "../../util/TraceUtil";

import {getRealLabel, getRefID, htmlspecialchars, renderPrimitiveObject} from "./RenderUtil";
import {renderCStructArray} from "./RenderUtilC";



export default ({heap, rootArr, connectionMap, lang}) => {

  let pointId = 0;

  const render = (index, objId, pid) => {
    if (index != null){
      objId = rootArr[index]
    }
    if (!objId){
      return <></>
    }
    let obj = heap[objId];
    if (!obj){
      return render(index + 1)
    }
    let kind = null
    if (obj.kind){
      kind = obj.kind
      obj = obj.val
    }
    //REF指向对象
    if (index == null){
      if (rootArr.includes(objId)) {
        let srcId = "v1__heap_pointer_src_" + pointId++;
        let tarId = generateHeapObjID(objId);
        connectionMap.set(srcId, tarId)

        return <div id={srcId}> </div>
      } else {
        //直接嵌入对象
        return renderHeapObject(obj, objId, kind)
      }
    }

    return (
      <>
      <table key={`heapRow${index}`} id={`heapRow${index}`} className="heapRow">
        <tbody>
        <tr>
          <td className="toplevelHeapObject" id={`toplevel_heap_object_${objId}`}>
            {renderHeapObject(obj, objId, kind)}
            {/*{index}*/}
          </td>
        </tr>
        </tbody>
      </table>
      {render(index + 1)}
      </>
    )
  }
  function renderHeapObject(obj, objId, kind) {
    const heapObjID = generateHeapObjID(objId);
    return (
      <div className="heapObject" id={heapObjID}>
        {renderTypeLabel(obj)}
        {renderCompoundObject(obj, objId)}
        {kind === 'readonly_memory' ? <div className="readonlyMemoryFooter">(this is in read-only storage, not the heap)</div>: <></>}
      </div>
    )
  }

  function renderTypeLabel(obj) {
    const TYPE = obj[0]
    const type = TYPE.toLowerCase();
    const varName = obj[1]
    let typeLabel;

    switch (TYPE) {
      case 'CLASS':
        typeLabel = `${varName} class`
        break;
      case 'FUNCTION':
        typeLabel = getRealLabel(type)
        break;
      case 'LIST':
      case 'TUPLE':
      case 'SET':
      case 'DICT':
        typeLabel = getRealLabel(type)
        if (obj.length === 1) {
          typeLabel= "empty " + typeLabel
        }
        break;
      case 'INSTANCE':
        typeLabel = `${varName} ${getRealLabel(type)}`
        break;
      case 'C_ARRAY':
      case 'JS_FUNCTION':
        return <></>

      default:

        typeLabel = "todo : typeLabel" + TYPE
    }
    return (
      <div className="typeLabel">{typeLabel}</div>
    )

  }

  const renderCompoundObject = (obj, objId) => {

    const type = obj[0]
    const label = type.toLowerCase();
    const varName = obj[1]
    const isInstance = (type === 'INSTANCE');
    let values;
    switch (type) {
      case 'CLASS': case 'INSTANCE':
        let [_,headerLength] = getClassInstanceMetadata(obj);
        if (obj.length  <= headerLength) {
          return (<></>)
        }
        const kvPairArr = obj.slice(headerLength);
        const lab = isInstance ? 'inst' : 'class';
        return (
          <table className={`${lab}Tbl`}>
            <tbody>
            {kvPairArr.map((kvPair, i) =>
              (
                <tr key={i} className={`${lab}Entry`}>
                  <td className={`${lab}Key`}>
                    {
                      typeof kvPair[0] === "string" ? <span className={`${lab}Obj`}>{kvPair[0]}</span> :
                        renderNestedObject(kvPair[0], objId)
                    }
                  </td>
                  <td className={`${lab}Val`}>
                    {renderNestedObject(kvPair[1], objId)}
                  </td>
                </tr>
              )
            )}
            </tbody>
          </table>

        )
      case 'LIST':
      case 'TUPLE':
        if (obj.length === 1){
          return <></>
        }
        values = obj.slice(1);
        return (
          <table className={label + "Tbl"}>
            <tbody>
            <tr>
              {values.map((_, i) => (
                <td key={ i} className={label + "Header"}>{i}</td>
              ))}
            </tr>
            <tr>
              {values.map((v, i) => (
                <td key={ i} className={label + "Elt"}>{renderNestedObject(v,objId)}</td>
              ))}
            </tr>
            </tbody>
          </table>


        )
      case 'SET':
        if (obj.length === 1){
          return <></>
        }
        values = obj.slice(1);
        return (
          <table className={label + "Tbl"}>
            <tbody>
            <tr>
              {values.map((v, i) => (
                <td key={ i} className={label + "Elt"}>{renderNestedObject(v,objId)}</td>
              ))}
            </tr>
            </tbody>
          </table>


        )
      case 'DICT':
        if (obj.length === 1){
          return <></>
        }
        values = obj.slice(1);
        return (
          <table className={label + "Tbl"}>
            <tbody>
            {values.map((v, i) => (
            <tr key={i} className={label + "Entry"}>
                <td className={label + "Key"}>{renderNestedObject(v[0],objId)}</td>
                <td className={label + "Val"}>{renderNestedObject(v[1],objId)}</td>
            </tr>
            ))}
            </tbody>
          </table>


        )
      case 'FUNCTION':
        const funcName = htmlspecialchars(varName).replace('&lt;lambda&gt;', '\u03bb');
        const parentFrameID = obj[2]; // optional
        return (
          <>
          <div className="funcObj">{funcName} {parentFrameID?`[parent=f${parentFrameID}]`:''}</div>
          { obj.length > 3 && obj[3].length>0 && (
            <>
              <div className="typeLabel" style={{'marginTop': '3px'}}>default arguments:</div>
              <table className="instTbl">
                <tbody>
                {obj[3].map((kvPair, i) =>
                (
                  <tr key={i} className="instEntry">
                    <td className="instKey">
                      <span className="keyObj">{kvPair[0]}</span> :
                    </td>
                    <td className="instVal">
                      {renderNestedObject(kvPair[1], objId)}
                    </td>
                  </tr>
                )
                )}
                </tbody>
              </table>
            </>
          )
          }
          </>
        );
      case 'JS_FUNCTION':
        return (
          <pre className="funcCode">{obj.length > 2 ? obj[2] : varName }</pre>
        );
      case 'C_STRUCT':
      case 'C_ARRAY':
      case 'C_MULTIDIMENSIONAL_ARRAY':
        return renderCStructArray(obj, renderNestedObject, lang);
      default:
        return (
          <>{objId}-{obj[0]}-{obj[1]}</>
        )
    }
  }
  const renderNestedObject = (obj, pid) => {
    if (isPrimitiveType(obj)) {
      return renderPrimitiveObject(obj, connectionMap)
    }
    if (obj[0] === 'REF') {
      let objId = getRefID(obj);
      return render(null, objId, pid);
    } else {
      assert(obj[0] === 'C_STRUCT' || obj[0] === 'C_UNION' || obj[0] === 'C_ARRAY' || obj[0] === 'C_MULTIDIMENSIONAL_ARRAY');
      return renderCStructArray(obj, renderNestedObject, lang);
    }

  }


  return (
    <>
      {render(0)}
    </>
  )
}
